/* eslint-disable react-hooks/exhaustive-deps */
import { AreaForm } from "./styles";
import { React, useState, useEffect, useRef, useContext } from 'react';
import '../styles/styles.css'
import './style.css'


import img from '../assets/iconesMenu/logo-censo-verde.svg'
import inicio from '../assets/iconesMenu/icone-inicial .svg'
import escola from '../assets/iconesMenu/icone-escola.svg'
import aluno from '../assets/iconesMenu/icone-aluno.svg'
import gestor from '../assets/iconesMenu/icone-gestor.svg'
import turma from '../assets/iconesMenu/icone-turma.svg'
import profissional from '../assets/iconesMenu/icone-profissional.svg'
import { MessageContext } from "../context/message";
import MessageGlobal from "../Components/messageGlobal";
import { DataSchoolContext } from "../context/dataSchool";
import { authContext } from "../context/auth";
import { useNavigate } from "react-router";



function App({ children, scroll, names, visibled }) {
  const { errorMessage  } = useContext(MessageContext)
  const {dataSchool } = useContext(DataSchoolContext)
  const { setAuth} = useContext(authContext)
  const [visible, setVisible] = useState()
  const [userLog, setUserLog] = useState('');
  const navigate = useNavigate()
  const [constModal, setConstModal] = useState(false);
  const menudropRef = useRef();
  const siglaRef = useRef();
  useEffect(() => {
    setVisible(visibled ?? true)
    setUserLog(JSON.parse(sessionStorage.getItem('HomeLog')))


    var path = window.location.pathname;
    if (document.querySelector(`a[href="${path}"]`)) {
      var link = document.querySelector(`a[href="${path}"]`);
      link.style.border = '1px solid #009E3A';
    }

  }, [])

  function logout() {
    setAuth(false)
    sessionStorage.removeItem('censo')
    navigate('/login')

  }


  function modalParacer() {
    if (constModal) {
      setConstModal(false)
      return;
    }
    setConstModal(true)
  }


  useEffect(() => {
    function clickFora(event) {
      if (menudropRef.current && !menudropRef.current.contains(event.target) && !siglaRef.current.contains(event.target)) {
        if (constModal) {
          setConstModal(false)
        } else {
          setConstModal(false)

        }
      }
    }
    document.addEventListener('click', clickFora);
    return () => {
      document.removeEventListener('click', clickFora);
    };
  }, []);





  return (
    <>
      <div className='span-message'>
            {Object.values(errorMessage)?.map((item, key, index) => {
              return (
                <MessageGlobal ok={item.ok} key={key} myKey={key} text={item.message} />
              )
            })}
          </div>
      <div id="bloco-layout" style={{ overflow: scroll ? 'hidden' : 'auto', position: scroll ? 'fixed' : 'none' }}>
        <div className="bloco-menu">
          <a href="/Home" color="red"><img alt="" src={img} /><span className="nomeEscola">{dataSchool?.schoolName}</span></a>

          <div id="bloco-menu-sigla">
            <div id="links-menu">
              <a  href="/home" style={{ display: visible ? null : 'none' }}><img alt="" src={inicio} /> <span className="nomelink">Página Inicial</span></a>
              <a  href="/escola/editar-identificacao"><img alt="" src={escola} /><span className="nomelink">Escola</span></a>
              <a  href="/gestor/pesquisar"> <img alt="" src={gestor} /> <span className="nomelink">Gestor</span></a>
              <a  href="/turma/pesquisar"> <img alt="" src={turma} /> <span className="nomelink">Turma</span></a>
              <a  href="/aluno/pesquisar"> <img alt="" src={aluno} /><span className="nomelink">Aluno</span></a>
              <a  href="/profissional/pesquisar"> <img alt="" src={profissional} /><div className="nomelink">Profissional Escolar</div></a>
            </div>
            <div className="card-perfil-sigla" >
              <div ref={siglaRef} className={`info-sigla ${constModal ? 'is-actived' : ''}`} onClick={() => modalParacer()}>
                {userLog?.iniciais}
              </div>

              {constModal ?
                <div ref={menudropRef} className="menudrop">
                  <div className="perfilbloco">
                    <div className="info-sigla perfil">
                      <p>{userLog?.iniciais}</p>
                    </div>
                    <p>{userLog?.completeName}</p>
                  </div>
                  <button id="button-logout" onClick={() => logout()}><small>Sair</small></button>
                </div> : ''
              }
            </div>

          </div>
        </div>
        <AreaForm >
          {children}
        </AreaForm>
      </div>
    </>
  );
}

export default App;
